import './index.scss';

import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import Axios from '@/src/axiosPool';
import DiscardChanges from '@/src/components/common/DiscardChanges/DiscardChanges';
import NavigationBLocker from '@/src/components/common/NavigationBlocker/NavigationBlocker';
import { showToast } from '@/src/globalFunction';
import { cn } from '@/src/util/ui';

import { getSections } from './Config';
import Field from './Fields/Field/Field';

@connect((store) => {
  return {
    project: store.project,
    loggedUser: store.loggedUser,
  };
})
class Profile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      layout: 'view',
      fields: {
        projectName: '',
        country: '',
        building: '',
        city: '',
        region: '',
        postalCode: '',
        legalStatus: '',
        industry: '',
        registrationDate: null,
        tinNo: null,
        revenueDistrictOffice: '',
      },
      error: false,
    };

    _.map(['onChangeView', 'onUpdateFields', 'onSubmit', 'discardChanges'], (fn) => {
      this[fn] = this[fn].bind(this);
    });
  }

  componentDidMount() {
    const location = Object.assign({}, this.props.history.location);
    const qs = new URLSearchParams(location.search);
    const proceed = qs.get('proceed');

    if (proceed) {
      this.onChangeView(null, 'form');

      this.props.history.push({ ...this.props.history.location, search: null });
    }
  }

  onChangeView(e, view) {
    const { project } = this.props;
    const selected = project.Selected || {};
    const company = selected.company;

    if (e) {
      e.preventDefault();
    }

    if (view === 'form') {
      this.setState({
        ...this.state,
        fields: {
          projectName: selected.project,
          country: company.country,
          building: company.building,
          city: company.city,
          region: company.region,
          postalCode: company.postalCode,
          legalStatus: company.legalStatus,
          industry: company.industry,
          registrationDate: company.registrationDate,
          tinNo: company.tinNo,
          revenueDistrictOffice: company.revenueDistrictOffice,
        },
        layout: view,
      });
    } else {
      this.setState({
        ...this.state,
        fields: {
          projectName: '',
          country: '',
          building: '',
          city: '',
          region: '',
          postalCode: '',
          legalStatus: '',
          industry: '',
          registrationDate: null,
          tinNo: null,
          revenueDistrictOffice: '',
        },
        layout: view,
      });
    }
  }

  onUpdateFields(e) {
    this.setState({
      ...this.state,
      fields: {
        ...this.state.fields,
        [e.target.id]: e.target.value,
      },
      error: e.error,
    });

    this.props.setIsSaveEanbled(!!e.error);
  }

  onSubmit() {
    const { project, dispatch } = this.props;
    const selected = project.Selected || {};
    const data = {
      projectName: this.state.fields.projectName,
      country: this.state.fields.country,
      building: this.state.fields.building,
      city: this.state.fields.city,
      region: this.state.fields.region,
      postalCode: this.state.fields.postalCode,
      legalStatus: this.state.fields.legalStatus,
      industry: this.state.fields.industry,
      tinNo: this.state.fields.tinNo,
      revenueDistrictOffice: this.state.fields.revenueDistrictOffice,
      registrationDate: this.state.fields.registrationDate
        ? moment(this.state.fields.registrationDate).format('DD-MMM YYYY')
        : null,
    };

    dispatch({ type: 'SET_SCREEN_LOADER', Loading: true });

    Axios.put(`api/companyAddress/${selected.company.id}`, data).then((response) => {
      if (response) {
        dispatch({
          type: 'SET_PROJECT_SELECTED',
          Selected: {
            ...selected,
            project: response.data.project.project,
            company: {
              ...selected.company,
              ...response.data.result,
            },
          },
        });
        this.setState({
          data: {
            ...selected.company,
            ...response.data.result,
          },
        });

        showToast('success', 'Changes successfully saved!');
      }

      this.onChangeView(null, 'view');

      dispatch({ type: 'SET_SCREEN_LOADER', Loading: false });
    });
  }
  discardChanges() {
    this.onChangeView(null, 'view');
    $('#companyProfile').modal('hide');
    showToast('success', 'Changes have been discarded');
  }

  render() {
    const { project, loggedUser } = this.props;
    const selected = project.Selected || {};
    const company = selected.company;
    const withPermission =
      loggedUser.data.id === selected.createdBy ||
      selected.leadId === loggedUser.data.id ||
      loggedUser.data.userRole < 4;
    const sections = getSections({
      selected,
      company: company || {},
      state: this.state,
      onUpdateFields: this.onUpdateFields,
      error: this.state.error,
    });
    const hasError = this.state.error;
    let hasChanges = selected.project !== this.state.fields.projectName;
    const updated = _.cloneDeep(this.state.fields);
    delete updated.projectName;
    Object.keys(updated).forEach((f) => {
      const value = updated[f] === '' ? null : updated[f];
      const isSame = company[f] === value;
      if (!isSame) {
        hasChanges = true;
        return;
      }
    });
    const handleCancel = (e) => {
      if (hasChanges) {
        $('#companyProfile').modal('show');
      } else {
        this.onChangeView(null, 'view');
      }
    };
    return (
      <div>
        <div className="memberFormContainer mt0 tw-relative">
          <div className="">
            {withPermission && (
              <React.Fragment>
                {this.state.layout === 'view' && (
                  <div className="formsHeaderActions tw-absolute tw-right-[5px] tw-top-[-60px]">
                    <div className="actionItem tw-text-[14px] tw-text-cfo-blue-600">
                      <a
                        href="/"
                        className="editProfile tw-flex tw-items-center"
                        onClick={(e) => this.onChangeView(e, 'form')}
                      >
                        <i className="material-icons tw-text-[20px] tw-mr-[7px]">edit</i>
                        Edit
                      </a>
                    </div>
                  </div>
                )}
                {this.state.layout === 'form' && (
                  <div className="formsHeaderActions tw-flex tw-absolute tw-right-0 tw-top-[-70px]">
                    <div className="actionItem">
                      <button
                        className={cn(
                          'btnCancel tw-bg-cfo-grey-100 tw-border tw-border-gray-200  tw-rounded-md tw-font-medium tw-px-[10px] tw-py-[6px] tw-ml-[10px]',
                          'tw-text-cfo-black',
                          'hover:tw-border-[#EAF0FF] hover:tw-bg-[#EAF0FF] hover:tw-text-cfo-blue-600'
                        )}
                        onClick={handleCancel}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="actionItem">
                      {hasChanges ? (
                        <button
                          className={cn(
                            'tw-rounded-md tw-font-medium tw-px-[10px] tw-py-[6px] tw-ml-[10px] tw-border-gray-200',
                            'tw-text-cfo-black',
                            'tw-bg-cfo-blue-700 tw-border tw-border-tw-bg-cfo-blue-700 tw-text-white',
                            hasError && 'disabled disabled:tw-text-cfo-grey-600'
                          )}
                          disabled={hasError}
                          onClick={this.onSubmit}
                        >
                          Save
                        </button>
                      ) : (
                        <button
                          className={cn(
                            'btnSave tw-bg-cfo-grey-100 tw-border tw-border-cfo-grey-200 tw-text-gray-700 tw-rounded-md tw-font-medium',
                            'tw-px-[10px] tw-py-[6px] tw-ml-[10px]',
                            'disabled disabled:tw-text-cfo-grey-600 disabled:tw-pointer-events-none'
                          )}
                          disabled
                        >
                          Save
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </React.Fragment>
            )}
          </div>
          <div className="memberFormBody">
            <form id="profile-form" className="pt20">
              {sections.map((s) => (
                <div key={s.title} className={`formSection ${s.class ? s.class : ''}`}>
                  {s.title && (
                    <div className="formSectionTitle">
                      <h3>{s.title}</h3>
                    </div>
                  )}
                  {s.fields.map((f, index) => (
                    <Field
                      key={`sf_${index}`}
                      view={this.state.layout}
                      field={{
                        ...f,
                        onChange: this.onUpdateFields,
                      }}
                    />
                  ))}
                </div>
              ))}
            </form>
          </div>
        </div>

        <DiscardChanges onCancel={this.discardChanges} id={'companyProfile'} />
        <NavigationBLocker navigationBlocked={hasChanges && this.state.layout === 'form'} />
      </div>
    );
  }
}

export default withRouter(Profile);
